// The pending merchant offer, read off the snapshot.
import type { GameSnapshot } from '@aod/protocol';
import { useMemo } from 'react';
import { type PendingMerchantOffer, findPendingMerchantOffer } from '../sea/pendingOffer.js';

export type { PendingMerchantOffer };

/** The local player's harbour with a house at it, if any. */
export function usePendingMerchantOffer(
  snapshot: GameSnapshot | null,
  localPlayerIndex: number,
): PendingMerchantOffer | null {
  return useMemo(
    () => findPendingMerchantOffer(snapshot, localPlayerIndex),
    [snapshot, localPlayerIndex],
  );
}
